import InstagramIconDark from 'assets/images/icons/dark - instagram.svg?react';
import InstagramIconSimpleFiligree from 'assets/images/icons/simple filigree - instagram.svg?react';
import InstagramIconSpringVibes from 'assets/images/icons/spring - instagram.svg?react';
import InstagramIconVickyBaumannBoho from 'assets/images/icons/vicky boho - instagram.svg?react';
import InstagramIconVickyBaumannFineart from 'assets/images/icons/vicky fineart - instagram.svg?react';
import { IIconProps } from 'types/icons';
import { BaseIcon } from './BaseIcon';
import { SetIcon } from './SetIcon';
import { useTemplateVariant } from 'hooks/useTemplateVariant';

const LegacyInstagramIcon = (props: IIconProps) =>
  useTemplateVariant({
    classic: () => <BaseIcon icon={InstagramIconSimpleFiligree} {...props} />,
    dark: () => <BaseIcon icon={InstagramIconDark} {...props} />,
    simpleFiligree: () => <BaseIcon icon={InstagramIconSimpleFiligree} {...props} />,
    springVibes: () => <BaseIcon icon={InstagramIconSpringVibes} {...props} />,
    vickyBaumannBoho: () => <BaseIcon icon={InstagramIconVickyBaumannBoho} {...props} />,
    vickyBaumannFineart: () => <BaseIcon icon={InstagramIconVickyBaumannFineart} {...props} />,
    breeze: () => <BaseIcon icon={InstagramIconSimpleFiligree} {...props} />,
    capri: () => <BaseIcon icon={InstagramIconSimpleFiligree} {...props} />,
    rose: () => <BaseIcon icon={InstagramIconSimpleFiligree} {...props} />,
    calm: () => <BaseIcon icon={InstagramIconSimpleFiligree} {...props} />
  })();

export const InstagramIcon = (props: IIconProps) => (
  <SetIcon slug="instagram" fallback={LegacyInstagramIcon} {...props} />
);
